import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import {
  FormControl,
  InputLabel,
  Select,
  FilledInput,
  Typography,
  MenuItem,
  Box,
  FormHelperText
} from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  selectMenu: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem"
    }
  },
  filledSelect: {
    padding: theme.spacing(3.5, 4, 1, 1.5)
  },
  icon: {
    position: "inherit"
  }
}));

function DropdownSelectFilled(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    value,
    onChange,
    options,
    label,
    selectTagName,
    fullWidth,
    disableUnderline,
    color,
    margin,
    required,
    error,
    helperText
  } = props;

  function handleChange(event) {
    onChange(event.target.value);
  }

  return (
    <Box color={color} width="100%">
      <FormControl
        variant="filled"
        fullWidth={fullWidth}
        margin={margin}
        error={error}
        hiddenLabel={!label}
      >
        {!!label && (
          <InputLabel htmlFor="dropdown-select" required={required}>
            {label}
          </InputLabel>
        )}
        <Select
          disableUnderline={disableUnderline}
          onChange={handleChange}
          classes={{
            selectMenu: classes.selectMenu,
            filled: label ? classes.filledSelect : "",
            icon: classes.icon
          }}
          input={
            <FilledInput
              name={selectTagName}
              id="dropdown-select"
              value={value || ""}
            />
          }
          renderValue={value => (
            <Typography variant="body2">
              {value.label ? t(value.label) : t(value)}
            </Typography>
          )}
        >
          {!!options &&
            options.map((dropdownOption, index) => (
              <MenuItem
                value={dropdownOption}
                key={`${dropdownOption.value}-${index}`}
              >
                {dropdownOption.label
                  ? t(dropdownOption.label)
                  : t(dropdownOption)}
              </MenuItem>
            ))}
        </Select>

        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
}

export default DropdownSelectFilled;

DropdownSelectFilled.propTypes = {
  color: PropTypes.string,
  options: PropTypes.array.isRequired,
  selectTagName: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disableUnderline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(["dense", "normal", "none"]),
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string
};

DropdownSelectFilled.defaultProps = {
  margin: "none",
  fullWidth: true,
  dense: false,
  required: false,
  error: false,
  helperText: ""
};
